var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Info_Icon",
    width: 14.5,
    height: 14.5,
    "data-name": "Info Icon",
    viewBox: "0 0 14.5 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#117093}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_173",
    d: "M43.25 376a7.25 7.25 0 1 0 7.25 7.25 7.258 7.258 0 0 0-7.25-7.25zm0 12.932a5.682 5.682 0 1 1 5.682-5.682 5.689 5.689 0 0 1-5.682 5.682z",
    className: "prefix__cls-1",
    "data-name": "Path 173",
    transform: "translate(-36 -376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_174",
    d: "M51.831 385.17a1.332 1.332 0 1 0-1.332-1.332 1.332 1.332 0 0 0 1.332 1.332zm1.294 2.72a1.521 1.521 0 0 0-1.481-1.87H50.5a.392.392 0 0 0-.392.392.332.332 0 0 0 .1.225.829.829 0 0 1 .228.759l-.6 2.446a1.522 1.522 0 0 0 1.481 1.87h1.143a.392.392 0 0 0 .392-.392.333.333 0 0 0-.1-.225.827.827 0 0 1-.228-.759z",
    className: "prefix__cls-1",
    "data-name": "Path 174",
    transform: "translate(-44.385 -379.956)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.e41e7c2bdc90fe9f0af4cb6ac6cda976.svg";
export { ForwardRef as ReactComponent };